import { render } from "./WisdomToothExtraction.vue?vue&type=template&id=7f488c2c"
import script from "./WisdomToothExtraction.vue?vue&type=script&lang=js"
export * from "./WisdomToothExtraction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__